import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { SessionData, SessionService } from "@app/core/services/session.service";
import { getBackofficeUrl, isClientSideExecution } from "@app/core/utils";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-unleash-section",
    templateUrl: "./unleash-section.component.html",
    styleUrls: ["./unleash-section.component.scss"],
    standalone: false,
})
export class UnleashSectionComponent implements OnInit, OnDestroy {
    ngUnsubscribe = new Subject<boolean>();
    isLogged = false;

    @Input() mobile: boolean = false;

    constructor(private sessionService: SessionService) {}

    ngOnInit() {
        this.sessionService.sessionData.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (sessionData: SessionData) => {
                this.isLogged = sessionData && sessionData.user ? true : false;
            },
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.unsubscribe();
    }

    goToConsole() {
        if (!this.sessionService.sessionData.value) {
            return;
        }

        const consoleUrl: string = getBackofficeUrl(this.sessionService.sessionData.value.account.types);
        if (consoleUrl) {
            if (isClientSideExecution()) {
                window.location.href = consoleUrl;
            }
        }
    }
}
